import { PREMIUM_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';

import { fg } from '@atlassian/jira-feature-gating';

import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { useIsOrgAdmin } from '@atlassian/jira-business-goal-picker/src/services/is-org-admin/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';

export const useShowCommunicationsMenu = () => {
	const { isOrgAdmin } = useIsOrgAdmin();
	const isSiteAdmin = useIsSiteAdmin();
	const isAdmin = useIsAdmin();

	const appEditions = useAppEditions();
	const tenantContext = useTenantContext();
	const { appPermissions } = tenantContext;
	// Check if user has premium edition
	const isPremium = appEditions?.software === PREMIUM_EDITION;

	// Check if user has specific product license
	const isJSMUser = appPermissions.hasServiceDeskAccess;
	const isAdminUser = isOrgAdmin || isSiteAdmin || isAdmin;

	const showCommunicationsMenu =
		isAdminUser && isPremium && isJSMUser && fg('communications_stakeholder_management_platform');

	return showCommunicationsMenu;
};
